<template>
  <div class="psd-skeleton-container">
    <div class="psd-skeleton-container-top">
      <div
        class="psd-skeleton-container-top-main"
        v-for="i in rows"
        :key="i"
        :class="{ 'psd-skeleton-container-top-main--dim': i !== 1 }"
      >
        <Skeleton height="20px" width="20px" borderRadius="4px" />
        <Skeleton
          height="18px"
          :width="textWidths[i - 1]"
          borderRadius="4px"
        />
      </div>
    </div>

    <div class="psd-skeleton-container-bottom">
      <Skeleton height="18px" width="170px" borderRadius="4px" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import Skeleton from '@/components/Skeleton/Skeleton';

const rows = 10;

const textWidths = computed(() => {
  const base = [144, 85, 100, 149, 63, 100, 105, 112, 148, 168];
  return base.map(w => `${w}px`);
});
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/variables.scss';
  
  .psd-skeleton-container {
    display: flex;
    width: 262px;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  
    &-top,
    &-bottom {
      align-self: stretch;
      background: $colorN00;
    }
  
    &-top {
      display: flex;
      padding: 12px 0;
      flex-direction: column;
      align-items: flex-start;
      border-radius: 8px;
  
      &-main {
        display: flex;
        padding: 16px 12px;
        align-items: center;
        gap: 8px;
        align-self: stretch;
        border-bottom: 0.5px solid $colorD20;
  
        &:last-child {
          border-bottom: none;
        }
  
        &--dim {
          opacity: 0.8;
        }
      }
    }
  
    &-bottom {
      display: flex;
      height: 40px;
      padding: 11px 20px;
      justify-content: center;
      align-items: center;
      gap: 2px;
      border-radius: 6px;
    }
  }
  </style>
  